import i18n from '@/i18n'

export function formatDuration(seconds) {
  let str = ''
  let _minutes = 0
  let _hours = 0
  if (seconds >= 3600) {
    _hours = Math.floor(seconds / 3600)
    str = _hours + i18n.tc('common.Hour')
    seconds = seconds % 3600
  }
  if (seconds >= 60) {
    _minutes = Math.floor(seconds / 60)
    str += _minutes + i18n.tc('common.Minute')
    seconds = seconds % 60
  }

  if (seconds > 0) {
    if (_minutes > 0) {
      str += seconds + i18n.tc('common.Second')
    } else if (_hours > 0) {
      str += '0' + i18n.tc('common.Minute') + seconds + i18n.tc('common.Second')
    } else {
      str = seconds + i18n.tc('common.Second')
    }
  }
  return str
}

export function getSplitTime(seconds) {
  let str = ''
  let _minutes = 0
  let _hours = 0
  if (seconds >= 3600) {
    _hours = Math.floor(seconds / 3600)
    str = _hours > 9 ? String(_hours) : '0' + _hours
    str += ':'
    seconds = seconds % 3600
  }

  if (seconds >= 60) {
    _minutes = Math.floor(seconds / 60)
    str += _minutes > 9 ? String(_minutes) : '0' + _minutes
    seconds = seconds % 60
  } else {
    str += '00'
  }

  str += ':'
  str += seconds > 9 ? seconds : '0' + seconds

  return str
}
